import styled from 'styled-components'
import { Box, ButtonStyled, SpanStyled } from './Elements';
import { useTranslation } from 'react-i18next'

export const sliceProps = (props, sub) => {
    const { children, ...otherProps } = props;
    sub.forEach(prop => delete otherProps[prop]);
    return otherProps;
}


export const ButtonWithIcon = (props) => {
    const unwantedProps = ['icon', 'label', 'className'];
    return (
        <ButtonWrapper {...sliceProps(props, unwantedProps)} className={`d-flex align-items-center ${props.className || ''}`}>
            <button {...sliceProps(props, unwantedProps)} className={`${!props.icon ? 'Btn-icon' : ''}`} autoComplete='false'>
                {props.icon && (
                    <props.icon width='18px' />
                )}
                <SpanStyled color='var(--white)' size='15px'>{props.label ? props.label : ''}</SpanStyled>
            </button>
        </ButtonWrapper>
    )
}
export const ContactButton = (props) => {
    const unwantedProps = ['icon', 'label', 'className'];
    return (
        <ContactWrapper {...sliceProps(props, unwantedProps)} className={`d-flex align-items-center ${props.className || ''}`}>
            <button {...sliceProps(props, unwantedProps)} className={`${!props.icon ? 'Btn-icon' : ''}`} autoComplete='false'>
                <SpanStyled color='var(--white)' size='16px'>{props.label ? props.label : ''}</SpanStyled>
                {props.icon && (
                    <props.icon width='18px' />
                )}
            </button>
        </ContactWrapper>
    )
}
export const OffersBox = (props) => {
    const { t } = useTranslation()
    const WhatsApp = () => {
        const phoneNumber = '+966535316584';
        const whatsappURL = `https://wa.me/${phoneNumber}`;
        window.open(whatsappURL, '_blank');
    };
    const unwantedProps = ['city', 'desc', 'className', 'price', 'days'];
    return (
        <OffersBoxContainer
            className={`planWrapper ${props.className || ''}`}
            role="button"
            tabIndex={0}
            onClick={WhatsApp}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') WhatsApp(); }}
            {...sliceProps(props, unwantedProps)}
        >
            {props.price && (
                <Box className='planPriceSticker'>
                    <Box className='planPriceBadge'>
                        <span className='planPriceSpark' aria-hidden='true' />
                        <span className='planPriceValue'>{props.price}</span>
                        <span className='planPriceCurrency'>{t('CurrencySAR')}</span>
                    </Box>
                </Box>
            )}
            <Box className='planContent'>
                <Box className='planCity'>{props.city}</Box>
                <Box className='planDays'>{props.desc}</Box>
                <ContactButton label={t('BookNow')} padding='5px 15px' onClick={WhatsApp} />
            </Box>
        </OffersBoxContainer>
    )
}

export const ServicesBox = (props) => {
    const WhatsApp = () => {
        const phoneNumber = '+966535316584';
        const whatsappURL = `https://wa.me/${phoneNumber}`;
        window.open(whatsappURL, '_blank');
    };
    const unwantedProps = ['desc', 'className'];
    return (
        <ServicesBoxContainer
            className={`servicesWrapper ${props.className || ''}`}
            role="button"
            tabIndex={0}
            onClick={WhatsApp}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') WhatsApp(); }}
            {...sliceProps(props, unwantedProps)}
        >
            <Box className='servicesContent'>
                <Box className='servicesText'>{props.desc}</Box>
            </Box>
        </ServicesBoxContainer>
    )
}
export const InputWithIcon = (props) => {
    const unwantedProps = ['icon', "label" ];
    return (
        <InputStyledWrap className='position-relative' >
            <InputStyled {...sliceProps(props, unwantedProps)} className={`w-100 ${!props.icon ? 'no-icon' : ''}`} autoComplete='false' />
            {props.icon && (
                <props.icon width='18px' className='position-absolute' />
            )}
        </InputStyledWrap>
    )
}
export const InputStyledWrap = styled.div`
    box-shadow: 3px 3px 10px #e3e3e3e0;
    -webkit-box-shadow: 3px 3px 10px #e3e3e3e0;
    -moz-box-shadow: 3px 3px 10px #e3e3e3e0;
    border-radius: 25px;
    background: var(--white);
    svg {
    left: 13px;
    top: 12px;
    height: 20px;
    }
`
export const InputStyled = styled.input`
    border: none;
    // box-shadow: 3px 3px 10px #e3e3e394;
    border-radius: 25px;
    height: 43px;
    color: var(--darkGrey) !important;
    &:not(.no-icon) {
        padding-left: 50px;
    }
    &.no-icon {
        padding-left: 18px;
    }
    padding-right: 18px;
    outline: none;
    &,&::placeholder {
        font-size: 13px;
        color: #a9a9a9 !important;
    }
`
export const OffersBoxContainer = styled.div`
    display: flex;
    width: 100%;
    height: 200px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 22px 10px 22px 10px;
    border-radius: 17px;
    overflow: hidden;
    align-items: flex-end;
    margin: 15px 0 15px 0;
    float: left;
    position: relative;
    cursor: pointer;
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.18);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
    &::before{
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(180deg, rgba(0,0,0,0.05) 35%, rgba(0,0,0,0.55) 100%);
        pointer-events: none;
        z-index: 0;
    }
    &:hover{
        transform: translateY(-3px);
        box-shadow: 0 14px 28px rgba(0, 0, 0, 0.24);
        .planPriceSticker{
            transform: rotate(-12deg) translateY(-2px);
        }
    }
    .planPriceSticker{
        position: absolute;
        top: 18px;
        left: 10px;
        z-index: 3;
        width: auto;
        height: auto;
        transform: rotate(-16deg);
        transform-origin: center left;
        transition: transform 0.25s ease;
        pointer-events: none;
        direction: ltr;
    }
    .planPriceBadge{
        position: relative;
        z-index: 2;
        display: inline-flex;
        align-items: baseline;
        justify-content: center;
        gap: 4px;
        min-width: 78px;
        padding: 6px 10px 7px;
        border-radius: 9px;
        color: var(--white);
        background: linear-gradient(180deg, #FF9A3D 0%, var(--themeColor) 55%, #E86E00 100%);
        border: 1px solid rgba(255,255,255,0.4);
        box-shadow:
            0 6px 12px rgba(255, 131, 25, 0.35),
            0 1.5px 0 #c45a00,
            inset 0 1px 0 rgba(255,255,255,0.5);
        &::after{
            content: '';
            position: absolute;
            inset: -3px -4px -4px -3px;
            border-radius: 11px;
            border: 1.5px solid rgba(255, 131, 25, 0.75);
            z-index: -1;
            transform: translate(2px, 2px);
            opacity: 0.9;
            pointer-events: none;
        }
        .planPriceSpark{
            position: absolute;
            top: -4px;
            right: -8px;
            width: 15px;
            height: 13px;
            z-index: 4;
            background:
                linear-gradient(128deg, transparent 38%, #fff 38%, #fff 46%, transparent 46%),
                linear-gradient(128deg, transparent 50%, #fff 50%, #fff 56%, transparent 56%),
                linear-gradient(128deg, transparent 62%, var(--themeColor) 62%, var(--themeColor) 70%, transparent 70%);
            opacity: 0.95;
            filter: drop-shadow(0 1px 1px rgba(0,0,0,0.15));
            pointer-events: none;
        }
        .planPriceValue{
            font-family: var(--semiBold);
            font-size: 14px;
            line-height: 1;
            letter-spacing: 0.2px;
        }
        .planPriceCurrency{
            font-family: var(--medium);
            font-size: 9px;
            line-height: 1;
            opacity: 0.95;
        }
    }
    @media (max-width: 991px) {
        .planPriceSticker{
            top: 16px;
            left: 10px;
            transform: rotate(-15deg) scale(0.95);
        }
    }
    @media (max-width: 575px) {
        .planPriceSticker{
            top: 14px;
            left: 8px;
            transform: rotate(-14deg) scale(0.88);
            transform-origin: center left;
        }
        .planPriceBadge{
            min-width: 70px;
            padding: 5px 8px 6px;
            border-radius: 8px;
            .planPriceSpark{
                width: 12px;
                height: 10px;
                top: -3px;
                right: -6px;
            }
            .planPriceValue{
                font-size: 13px;
            }
            .planPriceCurrency{
                font-size: 8px;
            }
        }
    }
    .planContent{
        display: flex;
        width: 100%;
        justify-content: center;
        text-align: center;
        color: var(--white);
        flex-wrap: wrap;
        position: relative;
        z-index: 1;
        .planCity{
            width: 100%;
            font-family: var(--semiBold);
            font-size: 22px;
            line-height: 26px;
            text-shadow: 0 1px 6px rgba(0,0,0,0.45);
        }
        .planDays{
            width: 100%;
            font-family: var(--regular);
            font-size: 14px;
            line-height: 16px;
            margin-bottom: 8px;
            text-shadow: 0 1px 4px rgba(0,0,0,0.4);
        }
        
    }
`

export const ServicesBoxContainer = styled.div`
    display: flex;
    width: 100%;
    height: 230px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom 0 left 0;
    padding: 22px 10px 22px 10px;
    border-radius: 17px;
    overflow: hidden;
    align-items: flex-end;
    margin: 12px 0 12px 0;
    float: left;
    position: relative;
    cursor: pointer;
    &::after{
        content: '';
        width: 100%;
        bottom: 0px;
        background: rgb(0,0,0);
        background: linear-gradient(0deg, rgba(0,0,0,0.73) 0%, rgba(0,0,0,0) 100%);
        position: absolute;
        z-index: 1;
        height: 110px;
        left: 0;
        right: 0;
    }
    .servicesContent{
        display: flex;
        width: 100%;
        justify-content: center;
        text-align: center;
        color: var(--white);
        flex-wrap: wrap;
        position: relative;
        z-index: 2;
        .servicesText{
            width: 100%;
            font-family: var(--medium);
            font-size: 16px;
            line-height: 18px;
        }
        
    }
`

export const ContactWrapper = styled.div`
  button {
    display: flex;
    align-items: center;
    background:${props => props.bg ? props.bg : "var(--gradientBlue)"};
    color: ${props => props.color ? props.color : "var(--white)"};
    padding: ${props => props.padding ? props.padding : "10px 20px"};
    border: ${props => props.border ? props.border : "none"};
    outline: ${props => props.border ? props.border : "none"};
    border-radius: ${props => props.radius ? props.radius : "20px"};
    box-shadow: ${props => props.shadow ? props.shadow : ""};
    line-height: 20px;
    gap: 8px;
    margin:0 0px;
    transition: all 0.5s ease;
    svg{
        [stroke]{
            stroke: ${props => props.stroke ? props.stroke : "var(--white)"} ;
        }
        [fill]{
            fill: ${props => props.fill ? props.fill : "var(--white)"};
        }
    }
    &:hover{
        background:transparent;
        outline:1px solid var(--themeColor);
        color:var(--themeColor);
        svg{
            [stroke]{
                stroke: ${props => props.stroke ? props.stroke : "var(--themeColor)"} ;
            }
            [fill]{
                fill: ${props => props.fill ? props.fill : "var(--themeColor)"};
            }
        }
        span{
            color:var(--themeColor);
        }
    }

  }
`
export const ButtonWrapper = styled.div`
  button {
    display: flex;
    align-items: center;
    background-color:${props => props.bg ? props.bg : "transparent"};
    color: ${props => props.color ? props.color : "var(--themeColor)"};
    padding: ${props => props.padding ? props.padding : "6px 16px"};
    border: ${props => props.border ? props.border : "1px solid var(--themeColor)"};
    border-radius: ${props => props.radius ? props.radius : "20px"};
    background: transparent;
    gap: 8px;
    transition: all 0.5s ease;
    &:hover{
        background-color: var(--themeColor);
        border: 1px solid var(--themeColor);
        color: var(--white);
        svg{
            [stroke]{
                stroke: var(--white);
            }
            [fill]{
                fill: var(--white);
            }
        }
    }
    
}
`